import { SelectOption } from "@/@types/SelectOption";
import { IProgramacaoColetaAnalise } from "@/interfaces/IProgramacaoColetaAnalise";
import { api } from "@/services/api";
import { programacaoAction } from "@/store/actions/programacao";
import { getProgramacaoSynced } from "@/store/reducers/programacaoColetaAnalise";
import dayjs from "dayjs";
import { useState } from "react";
import { useAuth } from "react-oidc-context";
import { useDispatch, useSelector } from "react-redux";

export const useProgramacaoColetaAnalise = () => {
  const { user } = useAuth();
  const appDispatch = useDispatch();
  const { sync } = programacaoAction;
  const listaProgramacoes = useSelector(getProgramacaoSynced);
  const [programacoesOptions, setProgramacoesOptions] = useState<
    SelectOption[]
  >([]);

  const sincronizarProgramacoes = (items: IProgramacaoColetaAnalise[]) => {
    appDispatch(sync(items));
  };

  const getProgramacoesApi = async () => {
    const { data } = await api.get<IProgramacaoColetaAnalise[]>(
      `/programacoes-coleta-analise/todas`,
      {
        headers: {
          Authorization: `Bearer ${user?.access_token}`,
        },
      }
    );
    return data;
  };

  const getProgramacoesByEstabelecimento = (estabelecimentoId: number) => {
    const programacoes = listaProgramacoes.filter(
      (programacao) =>
        programacao.estabelecimento.id === estabelecimentoId &&
        programacao.ativo
    );

    const options = programacoes.map((programacao) => {
      const itemLabel = programacao.agua
        ? "Água"
        : `${programacao?.produto?.produto?.nome} - ${programacao?.produto?.numeroRotulo}`;

      return {
        label: `${dayjs(programacao.dataProgramada).format("DD/MM/YYYY")} - ${itemLabel}`,
        value: programacao.id,
      };
    });

    setProgramacoesOptions(options);
  };

  const getProgramacaoById = (id: number) => {
    return listaProgramacoes.find((programacao) => programacao.id === id);
  };

  return {
    listaProgramacoes,
    sincronizarProgramacoes,
    getProgramacoesApi,
    programacoesOptions,
    getProgramacoesByEstabelecimento,
    getProgramacaoById,
  };
};
